export default "__VITE_ASSET__7H5hw9_L__"